import { callApi, sortingApiMap } from 'utils';
import { getI18nLng } from 'utils/i18n';
import { videoModel } from 'common/api/models';

/**
 * @param {string} videoId
 * @return {Promise<videoModel>}
 */
export function fetchVideoApi(videoId) {
  const language = getI18nLng();
  return callApi(`videos/${videoId}?lang=${language}`).then(videoModel);
}

/**
 * @return {Promise<videoModel>}
 */
export function fetchHomeVideoApi() {
  const language = getI18nLng();
  return callApi(`videos/home?lang=${language}`).then(videoModel);
}

/**
 * @param {string} videoId
 * @return {Promise<T>}
 */
export function deleteVideoApi(videoId) {
  return callApi(`videos/${videoId}`, 'DELETE');
}

/**
 *
 * @param {string} videoId
 * @param {[]} data
 * @returns {Promise.<T>}
 */
export function addVideoCommentApi(videoId, data) {
  return callApi(`videos/${videoId}/comments`, 'POST', data);
}

/**
 *
 * @param {string} videoId
 * @returns {Promise.<T>}
 */
export function fetchVideoCommentsApi(videoId) {
  return callApi(`videos/${videoId}/comments`);
}

/**
 * @param {string} videoId
 * @param {number} commentId
 * @returns {Promise.<T>}
 */
export function removeVideoCommentApi(videoId, commentId) {
  return callApi(`videos/${videoId}/comments/${commentId}`, 'DELETE');
}

/**
 * @param {number} channelId
 * @param {string} videoId
 * @return {Promise<T>}
 */
export function markVideoFeaturedApi(channelId, videoId) {
  return callApi(`channels/${channelId}/featured_videos/${videoId}`, 'POST');
}

/**
 * @param {number} channelId
 * @param {string} videoId
 * @return {Promise<T>}
 */
export function unMarkVideoFeaturedApi(channelId, videoId) {
  return callApi(`channels/${channelId}/featured_videos/${videoId}`, 'DELETE');
}

/**
 * @param {number} channelId
 * @param {string} videoId
 * @return {Promise<T>}
 */
export function markAsStartVideoApi(channelId, videoId) {
  return callApi(`channels/${channelId}/start_video/${videoId}`, 'POST');
}

/**
 * @param {number} channelId
 * @param {string} videoId
 * @return {Promise<T>}
 */
export function unMarkAsStartVideoApi(channelId, videoId) {
  return callApi(`channels/${channelId}/start_video/${videoId}`, 'DELETE');
}

/**
 * @param {number} videoId
 * @return {Promise<T>}
 * */
export function fetchVideoAttachmentsApi(videoId) {
  return callApi(`videos/${videoId}/attachments`);
}

/**
 * @param {number} pageNum
 * @param {number} perPage
 * @param {string} sortingKey
 * @param {string} sortingOrder
 * @return {Promise<T>}
 * */
export function fetchSortedVideosApi(pageNum, perPage, sortingKey, sortingOrder) {
  const language = getI18nLng();

  return callApi(
    `videos?pageNum=${pageNum}&perPage=${perPage}&sortingKey=${sortingKey}&sortingOrder=${sortingOrder}&lang=${language}`
  );
}

/**
 * @param {number} userId
 * @param {string} videoId
 * @return {Promise<T>}
 * */
export function pinVideoApi(userId, videoId) {
  return callApi(`users/${userId}/saved_videos/${videoId}`, 'POST');
}

/**
 * @param {number} userId
 * @param {string} videoId
 * @return {Promise<T>}
 * */
export function unpinVideoApi(userId, videoId) {
  return callApi(`users/${userId}/saved_videos/${videoId}`, 'DELETE');
}

/**
 * @return {Promise<T>}
 * */
export function fetchSavedVideosApi(userId, perPage, pageNumber, sort) {
  const language = getI18nLng();

  return callApi(
    `users/${userId}/saved_videos?pageNum=${pageNumber}${sortingApiMap(
      sort === 'recently_added' ? 'saved_date' : sort
    )}${perPage ? `&perPage=${perPage}` : ''}&lang=${language}`
  );
}

/**
 * @param {string} videoId
 */
export function fetchDownloadVideoApi(videoId) {
  return callApi(`videos/${videoId}/uit-download`);
}

/**
 * @param {string} videoId
 */
export function markHomeStartVideoApi(videoId) {
  return callApi(`videos/${videoId}/start-video`, 'POST');
}

/**
 * @param {string} videoId
 */
export function unmarkHomeStartVideoApi(videoId) {
  return callApi(`videos/${videoId}/start-video`, 'DELETE');
}

/**
 * @param {string} videoId
 * @param {string} path
 * @param {string} reportMessage
 */
export function reportVideoApi(videoId, path, reportMessage) {
  return callApi(`videos/${videoId}/report`, 'POST', { path, reportMessage });
}
